// @generated by tools/docgen — do not edit.
// Source: docs/examples/counter.md

import React from 'react';
import { CounterDemo } from './demo';
import {
  ExampleLayout,
  ExampleSection,
  ExampleSectionHeading,
  ExampleDescription,
  ExampleClientBadge,
} from '../../components/ExampleLayout';
import { SourceFile } from '../../components/SourceFile';

export function CounterPage() {
  return (
    <ExampleLayout title="Basic channel" demo={<CounterDemo />}>
      <ExampleSection position="first">
        <ExampleDescription>
          This is a simple counter, that demonstrate how state is forwarded to frontend, and how frontend can interact with backend channel. The widget at the right (or below depending on your screen) shows the same code in action.
        </ExampleDescription>
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-counter-backend">
        <ExampleSectionHeading id="examples-counter-backend">
          Backend
        </ExampleSectionHeading>
        <SourceFile path="counter/channels.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-counter-frontend" position="last">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <ExampleSectionHeading id="examples-counter-frontend">
            Frontend
          </ExampleSectionHeading>
          <ExampleClientBadge />
        </div>
        <SourceFile path="counter/demo.tsx" />
      </ExampleSection>
    </ExampleLayout>
  );
}

export default CounterPage;
